export { default } from './WrapperPopUp';



// WEBPACK FOOTER //
// ./src/components/Common/PopUps/WrapperPopUp/index.js